import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import "./plugins/axios";
import "./plugins/vee";
import "./plugins/vuetoastification";
import configs from "@/configs";
import setApiRoutes from "./helpers/setApiRoutes";
import * as ZnapComponents from '@znap/components-vue2';

import { getPermissions, filters, calendar, errorFunction } from "@/utils";
Vue.filter("dateFilter", filters.dateFilter);
Vue.filter("dateFilterTime", filters.dateFilterTime);
Vue.filter("floatFilter", filters.floatFilter);
Vue.filter("cpfCnpjFilter", filters.cpfCnpjFilter);
Vue.prototype.$calendar = calendar;
Vue.prototype.$fnError = errorFunction;
Vue.prototype.$getPermissions = getPermissions;

import { registerAllModules } from "handsontable/registry";
import { registerLanguageDictionary, ptBR } from "handsontable/i18n";
import numbro from "numbro";
import numbroptBR from "numbro/dist/languages/pt-BR.min.js";

numbro.registerLanguage(numbroptBR);
numbro.setLanguage("pt-BR");
registerAllModules();
registerLanguageDictionary(ptBR);

Vue.config.productionTip = false;

const { system, env } = configs;
setApiRoutes(Vue, system, env);

Vue.prototype.$vuetify = vuetify;

Vue.use(ZnapComponents.plugin, {
  licenseKey: process.env.VUE_APP_HOT_LICENSE_KEY
})

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
